import { Box, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'
import TableBodyCell from '../../../../../components/NewCustomTableElements/TableBodyCell'
import { getBackgroundColor } from '../../../../../helpers/getCorrectTableValue'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import {
  getIconFinancialSource,
  getTitleFinancialSource,
} from '../../../../../helpers/switchFinancialSource'
import tableBodyCellStyles from '../../../../../utils/components/CustomTable/styles/tableBodyCellStyles'
import { getStyles } from '../../../../../utils/utils/commonUtils'
import { getComp } from '../../../../../utils/utils/DI'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import {
  getCellBoxSx,
  getTypographySx,
} from '../../../../SingleServiceReport/styles/table.styles'
import NewBodyCheckBox from '../components/NewBodyCheckBox'
import { getCorrectRequestTableValue } from './getCorrectTableValue'

export const getCellContent = (
  key: string,
  el: RequestType,
  idx: number,
  data: any,
  checkboxStore: any,
) => {
  const { getStatusName, getStatusImage } = getComp('StatusesStore')
  const bodyCellClasses = getStyles(tableBodyCellStyles)
  const icon = getIconFinancialSource(el.financialSourceId)
  const backgroundColor =
    getBackgroundColor(el) ??
    (idx % 2 !== 0 ? 'rgba(217, 217, 217, 0.20)!important' : undefined)

  const value = getCorrectRequestTableValue(
    key as unknown as keyof RequestType,
    el,
  )

  if (key === 'checkbox') {
    return (
      <NewBodyCheckBox
        element={el}
        backgroundColor={backgroundColor}
        data={data}
        checkboxStore={checkboxStore}
      />
    )
  }

  switch (key) {
    case 'status':
      const src = getStatusImage(el.status)
      const tooltipName = getStatusName(el.status)

      return (
        <TableBodyCell
          backgroundColor={backgroundColor}
          key={key}
          customPadding='8px'
        >
          <Box sx={getCellBoxSx(bodyCellClasses)}>
            <Tooltip title={tooltipName} placement='top'>
              <img src={src} alt={'иконка статуса'} />
            </Tooltip>
          </Box>
        </TableBodyCell>
      )

    case 'isExpiredAssign':
      const expired = el.isExpiredAssign || el.isExpiredInstall

      return (
        <TableBodyCell
          backgroundColor={backgroundColor}
          key={key}
          customPadding='0!important'
        >
          <Box sx={{ ...getCellBoxSx(bodyCellClasses), paddingLeft: '16px' }}>
            {el.isSuspicious && (
              <Tooltip
                title={'Заявка отмечена как подозрительная'}
                placement='top'
              >
                <img
                  src={getImageSrc('isSuspicious')}
                  alt={'подозрительная заявка'}
                  style={{ width: '16px' }}
                />
              </Tooltip>
            )}
            {!el.isSuspicious && expired && (
              <Tooltip title={'Заявка не выполнена в срок'} placement='top'>
                <img
                  src={getImageSrc('isExpiredAssign')}
                  alt={'просроченная заявка'}
                  style={{ width: '16px' }}
                />
              </Tooltip>
            )}
          </Box>
        </TableBodyCell>
      )

    case 'financialSourceId':
      return (
        <TableBodyCell
          backgroundColor={backgroundColor}
          key={key}
          customPadding='0!important'
        >
          <Stack direction={'row'} spacing={'12px'} alignItems={'center'}>
            {icon && (
              <img src={icon} style={{ width: '22px', height: '22px' }} />
            )}
            <Typography variant='body1' fontSize={'14px'}>
              {getTitleFinancialSource(el.financialSourceId)}
            </Typography>
          </Stack>
        </TableBodyCell>
      )

    default:
      const isTerritory = key === 'locality'

      return (
        <TableBodyCell
          backgroundColor={backgroundColor}
          key={key}
          customPadding='8px'
        >
          <Box sx={getCellBoxSx(bodyCellClasses)}>
            {isTerritory ? (
              <Typography
                variant={'body1'}
                sx={getTypographySx(bodyCellClasses)}
              >
                {el.isDangerous && (
                  <Tooltip title={'Проблемная зона'} placement='top'>
                    <img
                      src={getImageSrc('isDangerous')}
                      alt=''
                      style={{ marginRight: '6px', marginBottom: '-3px' }}
                    />
                  </Tooltip>
                )}
                {el.duplicateAddressConfirmed && (
                  <Tooltip title={'Дубликат на адрес'} placement='top'>
                    <img
                      src={getStatusImage(10)}
                      alt=''
                      style={{
                        width: '16px',
                        marginRight: '6px',
                        marginBottom: '-3px',
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip title={value} placement='top'>
                  {value}
                </Tooltip>
              </Typography>
            ) : (
              <Typography
                variant={'body1'}
                sx={getTypographySx(bodyCellClasses)}
              >
                {value ?? '-'}
              </Typography>
            )}
          </Box>
        </TableBodyCell>
      )
  }
}
